/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Menu, Layout } from "antd";
import { Link } from "react-router-dom";
import {
  HomeFilled,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import { SHORTED_LOGO_URL } from "../constants/branding";

const { Content, Sider } = Layout;

const logoSrc = SHORTED_LOGO_URL;

const SiderBar = ({ openKey, selectedKey }) => {
  const isMobile = window.innerWidth < 530;
  const [collapsed, setCollapsed] = useState(isMobile);
  const menuProps = {
    className: "trigger vc-sider-trigger",
    onClick: () => setCollapsed(!collapsed),
    style: {
      padding: "8px",
      fontSize: "16px",
    },
  };
  return (
    <Sider
      width={200}
      className="site-layout-background"
      trigger={null}
      collapsed={collapsed}
      collapsedWidth={50}
      style={{ position: "relative", zIndex: 2 }}
    >
      {!isMobile && (
        <Content
          style={{
            position: "fixed",
            left: !collapsed ? "200px" : "50px",
            transition: "all 0.2s",
          }}
        >
          {collapsed ? (
            <MenuUnfoldOutlined {...menuProps} />
          ) : (
            <MenuFoldOutlined {...menuProps} />
          )}
        </Content>
      )}
      <Link
        to={`/`}
        style={{
          pointerEvents: collapsed ? "none" : "auto",
          display: "block",
        }}
        tabIndex={collapsed ? -1 : 0}
      >
        <div
          className="logo"
          style={{
            padding: "16px",
            minHeight: 90,
            boxSizing: "border-box",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src={logoSrc}
            width={150}
            height={58}
            alt="Shorted"
            style={{
              width: 150,
              height: 58,
              maxWidth: "100%",
              objectFit: "contain",
              opacity: collapsed ? 0 : 1,
              transition: "opacity 0.2s ease",
            }}
          />
        </div>
      </Link>
      <Menu
        mode="inline"
        selectedKeys={selectedKey}
        defaultOpenKeys={openKey}
        style={{ height: "100%", borderRight: 0, background: "transparent" }}
        theme="dark"
      >
        <Menu.Item key="1" icon={<HomeFilled />}>
          <Link to="/">Dashboard</Link>
        </Menu.Item>
        <Menu.Item key="2" icon={<WalletOutlined />}>
          <Link to="/payouts">Revenue</Link>
        </Menu.Item>
      </Menu>
    </Sider>
  );
};
export default SiderBar;
